<!--RLV:06Jul2022-->

<template>
    <div>
        <v-row>
            <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
                <v-text-field label="Search Here" v-model="searchQuery" class="py-0 my-0"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
                <v-select :items="searchOptions"
                          v-model="selectedSearchOption"
                          item-value="value"
                          item-text="text"
                          return-object
                          class="py-0 my-0"></v-select>
            </v-col>
        </v-row>

        <v-data-table :headers="newHeaders"
                      :items="items"
                      class="elevation-1"
                      :options.sync="pagination"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :footer-props="footerProps">
            <template slot="items" slot-scope="props">
                <td v-for="(header, index) in headers" :key="index">
                    <span v-if="!header.html">{{ props.item[header.value] }}</span>
                    <span v-if="header.html" v-html="props.item[header.value]">{{props.item[header.value]}}</span>
                </td>
            </template>
            <template v-slot:item.action="{ item }">
                <slot name="actions" v-bind:item="item"></slot>
            </template>

        </v-data-table>
    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    export default {
        props: {
            h: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            pagination: {
                page: 1,
                pageSize: 10
            },
            selectedSearchOption: {},
            searchQuery: "",
            searchBy: ""
        }),
        methods: {
            ...mapActions("esgrouping", [
                "getAll",
                "setPagination",
                "setSelectedSearchOption"
            ]),
            search() {
                const { value } = this.selectedSearchOption;
                this.searchBy = value;
                this.setSelectedSearchOption({
                    searchBy: this.searchBy,
                    searchQuery: this.searchQuery
                });

                this.getAll();
            }
        },
        computed: {
            ...mapState("esgrouping", {
                items: state => state.items,
                headers: state => state.headers,
                footerProps: state => state.footerProps,
                totalItems: state => state.totalItems,
                searchOptions: state => state.searchOptions,
                loading: state => state.loading
            }),
            newHeaders() {
                if (this.h.length > 0) {
                    return this.h;
                }
                return this.headers;
            }
        },
        watch: {
            pagination: {
                handler(val) {
                    this.setPagination(Object.assign({}, val));
                    this.search();
                },
                deep: true
            },
            searchQuery() {
                setTimeout(() => {
                    this.search();
                }, 500);
            },
            selectedSearchOption() {
                this.search();
            }
        },
        mounted() {
            this.selectedSearchOption = this.searchOptions[0];
        }
    };
</script>


